import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-md login-modal" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "close" }
const _hoisted_4 = { class: "button-content" }
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "field-wrapper password-wrapper" }
const _hoisted_7 = { class: "legacy-white-button legacy-text-button password-input" }
const _hoisted_8 = { class: "legacy-white-button legacy-text-button password-input mt-3" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "button-content" }
const _hoisted_11 = {
  key: 0,
  class: "text-alert mt-2"
}

export function render(_ctx, _cache) {
  const _component_legacy_icon = _resolveComponent("legacy-icon")
  const _component_Loading = _resolveComponent("Loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal fade", {'show': _ctx.show}]),
      tabindex: "-1"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "legacy-white-round-button",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.close()))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_legacy_icon, {
                  class: "times close-icon",
                  icon: "times"
                })
              ])
            ])
          ]),
          _renderSlot(_ctx.$slots, "content", {}, () => [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header" }, [
                _createElementVNode("h6", { class: "modal-title" }, "Login Fornecedor")
              ], -1))
            ], true),
            _renderSlot(_ctx.$slots, "body", {}, () => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      onKeyup: _cache[1] || (_cache[1] = $event => (_ctx.clearFailMessage())),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.login.email) = $event)),
                      placeholder: "E-mail",
                      class: "button-content"
                    }, null, 544), [
                      [_vModelText, _ctx.login.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      onKeyup: _cache[3] || (_cache[3] = $event => (_ctx.clearFailMessage())),
                      placeholder: _ctx.$t('password'),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.login.password) = $event)),
                      class: "button-content"
                    }, null, 40, _hoisted_9), [
                      [_vModelText, _ctx.login.password]
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "legacy-primary-button legacy-text-button enter-button",
                    onClick: _cache[5] || (_cache[5] = $event => (_ctx.authenticate()))
                  }, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('enter')), 1)
                  ]),
                  (_ctx.failLogin === true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.$t("login.invalid")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], true)
          ], true)
        ])
      ])
    ], 2),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "onUpdate:active": _cache[6] || (_cache[6] = $event => ((_ctx.loading) = $event)),
      "can-cancel": false,
      color: "#ff9100",
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}